import React from 'react';

const ProviderCard = ({ provider, selected, onSelect }) => {
  const { id, name, subtitle, description, badge, logo } = provider;

  return (
    <div
      className={`ec-provider-card${selected ? ' selected' : ''}`}
      onClick={() => onSelect(id)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onSelect(id); }}
    >
      {badge && (
        <span className={`ec-card-badge ${badge.type}`}>{badge.label}</span>
      )}

      <div className="ec-card-logo" style={{ background: logo.bg }}>
        {logo.node}
      </div>

      <div className="ec-card-name">{name}</div>
      <div className="ec-card-subtitle">{subtitle}</div>
      <div className="ec-card-desc">{description}</div>

      <div className="ec-card-select-row">
        <span className={`ec-card-select-text${selected ? ' selected-text' : ''}`}>
          {selected ? 'Selected' : 'Select'}
        </span>
        <div className={`ec-radio${selected ? ' checked' : ''}`}>
          {selected && <div className="ec-radio-inner" />}
        </div>
      </div>
    </div>
  );
};

export default ProviderCard;
